/* eslint-disable @typescript-eslint/naming-convention */
export const annualizedPercentFactor = 1200; // divide to turn rates expressed as a yearly percentage into a monthly decimal.
export const minStretchingDTI = 0.3; // DTI above this is considered stretching
export const maxStretchingDTI = 0.43; // DTI above this is considered aggressive
export const maxAffordability = 0.5; // This is the highest number we'll show on the slider.
export const sliderMinDTI = 0.2; // Target a DTI for the minimum value on the slider.
export const sliderMaxRange = 600_000; // Target a maximum range for the slider.
export const fallbackDownPayment = 20_000;
export const fallbackMonthlyDebt = 250;
export const fallbackAnnualIncome = 60_000;
export const conformingLoanLimit = 1149825;
